import { InjectionToken } from '@angular/core';

export class Environment 
{ 
    production: boolean; 
    version: string;
    dbSchema: string;
}

export const ENVIRONMENT = new InjectionToken<Environment>('Token for environment constant');
